import {
  OFFERS_LIST_SUCCESS,
  OFFERS_INFO_SUCCESS,
  OFFERS_UPDATE_SUCCESS,
  OFFERS_STATUS_SUCCESS,
  CLEAR_OFFERS_INFO,
} from "../actionTypes/offers";

const INIT_STATE = {
  offerList: [],
  offerInfo: {},
  queryInfo: { page: 1, size: 10 },
  totalRecords: 0,
  pages: 0,
};

function offersReducer(state = INIT_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case CLEAR_OFFERS_INFO:
      return {
        ...state,
        offerInfo: {},
      };
    case OFFERS_LIST_SUCCESS:
      return {
        ...state,
        offerList: payload.data || [],
        totalRecords: payload.count || 0,
        pages: payload.pages || 0,
        queryInfo: payload.queryInfo || state.queryInfo,
      };
    case OFFERS_INFO_SUCCESS:
      return {
        ...state,
        offerInfo: payload || {},
      };
    case OFFERS_UPDATE_SUCCESS:
    case OFFERS_STATUS_SUCCESS:
      return {
        ...state,
        offerInfo: payload || state.offerInfo,
        offerList: state.offerList.map((item) =>
          item._id === (payload && payload._id) ? payload : item
        ),
      };
    default:
      return state;
  }
}

export default offersReducer;
